import Alpine from 'alpinejs';
import { SearchBox } from './searchbox';
import { ContentWrapper } from './content_wrapper';
import { JumpToBottom } from './jump_to_bottom';
import { RecentSearches } from './recent_searches';
import { LoadingHandler } from './loading_handler';
import { SelectionHandler } from './selection_handler';
import { Tabs } from './tabs';
import { INITIAL_ACTIVE_TAB } from './config';
import { appStore } from '@/stores/app';
import { virtualKeyboardDetector } from '@/utils/virtual_keyboard_detector';

const globalData = appStore.getGlobalData();

const contentWrapper = new ContentWrapper(globalData.isMobile, virtualKeyboardDetector);
const jumpToBottom = new JumpToBottom();
const recentSearches = new RecentSearches();
const loadingHandler = new LoadingHandler();
const selectionHandler = new SelectionHandler();
const tabs = new Tabs(INITIAL_ACTIVE_TAB);

Alpine.data(
    'newSearchbox',
    () =>
        new SearchBox(
            globalData.isMobile,
            globalData.hideExplicitContent,
            jumpToBottom,
            contentWrapper,
            recentSearches,
            loadingHandler,
            selectionHandler,
            tabs
        )
);
